import { Button, Checkbox, TextArea } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'

import { ScheduledCommunicationTemplateMutations } from '@/graphql/mutations/scheduledCommunicationTemplate.mutations'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { ScheduledCommunicationTemplateList } from '@/types/ScheduledCommunicationTemplate'

import { formSchema, FormValuesType } from './EditScheduledCommunicationTemplateForm.util'

type Props = {
  refetchOnSuccess?: () => void
  scheduledCommunicationTemplate: ScheduledCommunicationTemplateList
  toggle: () => void
}

export const EditScheduledCommunicationTemplateForm = ({
  toggle,
  refetchOnSuccess,
  scheduledCommunicationTemplate,
}: Props) => {
  const [error, setError] = useState<string>()

  const { isTablet } = useMobile()

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(
    ScheduledCommunicationTemplateMutations.updateScheduledCommunicationTemplate(),
    {
      onSuccess: () => {
        refetchOnSuccess && refetchOnSuccess()
        toggle && toggle()
      },
      onError: (res: { response: { errors: { message: string }[] } }) => {
        const { response } = res
        if (response.errors && response.errors.length) {
          setError(response.errors[0].message)
        }
      },
    },
  )

  const handleSubmit = (values: FormValuesType) => {
    mutate({
      scheduledCommunicationTemplate: {
        scheduledCommunicationTemplateId: scheduledCommunicationTemplate.id,
        ...values,
      },
    })
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          active: scheduledCommunicationTemplate && scheduledCommunicationTemplate.active,
          content: scheduledCommunicationTemplate && scheduledCommunicationTemplate.content,
        }}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validationSchema={formSchema}
      >
        {() => {
          return (
            <Form className="flex min-h-140 w-full flex-col flex-wrap px-6 md:max-w-160">
              <p className="leading-nonemt-4 mb-4 font-bold text-header-md">Edit Scheduled Communication Template</p>

              <Checkbox className="mb-4 w-full" id="active" label="Active?" name="active" />
              <TextArea className="mb-4 w-full h-fit-content" label="Content" maxLength={1000} name="content" />

              {error && <p className=" mb-4 text-p-sm text-text-semantic-error">{error}</p>}
              <div className="flex flex-col-reverse justify-between md:flex-row">
                <Button
                  className="w-full bg-action-secondary md:flex md:w-auto"
                  onClick={toggle}
                  size={isTablet ? 'medium' : 'small'}
                  variant="secondary"
                >
                  Close
                </Button>
                <Button
                  className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
                  disabled={isMutationLoading}
                  isLoading={isMutationLoading}
                  size={isTablet ? 'medium' : 'small'}
                  type="submit"
                >
                  Update
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
